var _path, _circle, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeposits(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 25.0195C5.5 23.628 6.62802 22.5 8.01951 22.5V22.5C9.01768 22.5 9.92174 21.9107 10.3246 20.9975L12.392 16.3114C12.6302 15.7715 12.822 15.2122 12.9651 14.6396L13.2534 13.4863C13.8689 11.0246 16.6967 10.0154 18.0732 12.1471C18.6847 13.094 19.2146 14.2155 19.5 15.5H25H27.9296C35.7517 15.5 42.142 21.7467 42.3197 29.5667L42.3322 30.1153C42.4338 34.5877 39.838 38.6831 35.75 40.5V40.5V42.5C35.75 43.6046 34.8546 44.5 33.75 44.5H30.125C29.0204 44.5 28.125 43.6046 28.125 42.5V40.5H23.5V42.5C23.5 43.6046 22.6046 44.5 21.5 44.5H18C16.8954 44.5 16 43.6046 16 42.5V40.5C16 40.5 13.3382 39.8382 11 37.5C9.37566 35.8757 9.04295 34.0952 8.99121 33.1594C8.97185 32.8092 8.68972 32.5 8.33896 32.5V32.5C6.77105 32.5 5.5 31.229 5.5 29.661V25.0195Z",
    fill: "none",
    stroke: "current",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 24.5,
    r: 2,
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2898 9.5C28.1503 6.60851 30.8289 4.5 33.9999 4.5C37.8659 4.5 40.9999 7.63401 40.9999 11.5C40.9999 12.0149 40.9443 12.5168 40.8388 13",
    fill: "none",
    stroke: "current",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeposits);
export default __webpack_public_path__ + "static/media/deposits.addc35ded37610256cf28d0959f9b919.svg";
export { ForwardRef as ReactComponent };